import {
    ADD_BRAND_TO_TEAM,
    ADD_BRAND_TO_TEAM_FAIL,
    ADD_BRAND_TO_TEAM_SUCCESS,
    DELETE_BRAND_FROM_TEAM,
    DELETE_BRAND_FROM_TEAM_FAIL,
    DELETE_BRAND_FROM_TEAM_SUCCESS
} from './actionTypes';

const initialState = {
    teamId: null,
    add: {
        newBrand: null,
        addedBrand: null,
        error: null,
        loading: false,
        loaded: false
    },
    delete: {
        brandToBeDeleted: null,
        deletedBrand: null,
        error: null,
        loading: false,
        loaded: false
    }
};

export function teamBrandReducer(state = initialState, action) {
    switch (action.type) {
        case ADD_BRAND_TO_TEAM:
            return {
                ...state,
                teamId: action.payload.teamId,
                add: {
                    ...initialState.add,
                    newBrand: action.payload.brand,
                    loading: true
                }
            };
        case ADD_BRAND_TO_TEAM_SUCCESS:
            return {
                ...state,
                add: {
                    ...state.add,
                    addedBrand: action.payload,
                    loaded: true,
                    loading: false
                }
            };
        case ADD_BRAND_TO_TEAM_FAIL: {
            return {
                ...state,
                add: {
                    ...state.add,
                    error: action.payload,
                    loading: false
                }
            };
        }
        case DELETE_BRAND_FROM_TEAM:
            return {
                ...state,
                teamId: action.payload.teamId,
                delete: {
                    ...initialState.delete,
                    brandToBeDeleted: action.payload.brand,
                    loading: true
                }
            };
        case DELETE_BRAND_FROM_TEAM_SUCCESS:
            return {
                ...state,
                delete: {
                    ...state.delete,
                    deletedBrand: action.payload,
                    loaded: true,
                    loading: false
                }
            };
        case DELETE_BRAND_FROM_TEAM_FAIL: {
            return {
                ...state,
                delete: {
                    ...state.delete,
                    error: action.payload,
                    loading: false
                }
            };
        }
        default:
            return state;
    }
}
